module.exports = "/_next/static/images/404-2857875dce19bbafff026a879bd19481.png";